<template>
  <div>
    <div class="main"></div>
    <div class="am-padding-vertical-sm am-topbar-fixed-top forget-header">
      <a
        :href="siteConfig.logoLink == '' ? '#' : siteConfig.logoLink"
        v-show="siteConfig.logo"
        @click="handleToHome"
        class="fl logo"
      >
        <img :src="concatImageUrl(siteConfig.logo)" />
      </a>
      <div
        class="fr"
        style="font-size: 1.6rem; color: #fff; margin-top: 1.5rem"
      >
        <a href="/login" title="立即登录">立即登录</a>
        <span style="margin: 0 10px">|</span>
        <a href="#" title="网站首页" @click="handleToHome">网站首页</a>
      </div>
    </div>
    <div class="forget-wrap">
      <h3
        class="forget-title am-padding-vertical am-margin-horizontal am-text-lg"
      >
        找回密码
      </h3>
      <div class="steps">
        <Steps :current="step - 1">
          <Step title="输入信息" icon="ios-radio-button-on"></Step>
          <Step title="设置新密码" icon="ios-radio-button-on"></Step>
          <Step title="设置成功" icon="ios-radio-button-on"></Step>
        </Steps>
      </div>
      <div class="forget-tips">
        <template v-if="errorTip">
          <Icon type="md-alert" size="18" />
          <span>{{ errorTip }}</span>
        </template>
      </div>

      <!-- 第一步 -->
      <form v-if="step == 1" class="am-form am-margin-vertical forget-form">
        <div class="am-form-group am-form-icon">
          <i>
            <img
              src="../../assets/images/landing_phone.png"
              width="30"
              height="30"
            />
          </i>
          <input
            v-model="mobile"
            type="text"
            @input="checkUserName($event)"
            class="am-form-field am-input-lg am-radius"
            placeholder="请输入您的手机号"
          />
        </div>
        <div class="am-form-group am-margin-top-lg am-form-icon">
          <i>
            <img
              src="../../assets/images/landing_yanzhengma.png"
              width="30"
              height="30"
            />
          </i>
          <input
            v-model="imageCode"
            type="text"
            class="am-form-field am-input-lg am-radius"
            maxlength="6"
            placeholder="请输入图形验证码"
          />
          <span class="image-code" @click="getImageCodeUrl()">
            <img
              title="点击刷新"
              alt="验证码"
              :src="imageCodeUrl"
              style="cursor: pointer"
            />
          </span>
          <!-- <a
            class="am-btn am-btn-secondary mobile-code"
            @click="getPhoneCode"
            >{{ phoneCodeText }}</a
          > -->
        </div>
        <div class="am-form-group am-margin-top-lg am-form-icon">
          <i>
            <img
              src="../../assets/images/landing_yanzhengma.png"
              width="30"
              height="30"
            />
          </i>
          <input
            v-model="phoneCode"
            type="text"
            class="am-form-field am-input-lg am-radius"
            maxlength="6"
            placeholder="请输入手机验证码"
          />
          <a
            class="am-btn am-btn-secondary mobile-code"
            @click="getPhoneCode"
            >{{ phoneCodeText }}</a
          >
        </div>
        <div class="am-form-group am-margin-top-lg">
          <button
            type="button"
            class="am-btn am-btn-secondary am-btn-lg am-btn-block"
            @click="checkPhoneCode"
          >
            下一步
          </button>
        </div>
      </form>

      <!-- 第二步 -->
      <form v-if="step == 2" class="am-form am-margin-vertical forget-form">
        <div class="am-form-group am-form-icon">
          <i-input
            v-model.trim="password"
            type="password"
            password
            placeholder="请输入新的密码"
            class="am-psw"
          >
            <Icon custom="ich-icon ich-icon-lock" slot="prefix" />
          </i-input>
        </div>
        <div class="am-form-group am-margin-top-lg am-form-icon">
          <i-input
            v-model.trim="enterPassword"
            type="password"
            password
            class="am-psw"
            placeholder="请再次输入密码"
          >
            <Icon custom="ich-icon ich-icon-lock" slot="prefix" />
          </i-input>
          <div style="color: #808080">
            密码长度8-20位,需包含大小写字母,数字及特殊字符中的至少三种
          </div>
        </div>
        <div class="am-form-group am-margin-top-lg am-margin-top">
          <button
            type="button"
            @click="resetPassword"
            class="am-btn am-btn-secondary am-btn-lg am-btn-block"
          >
            确 认
          </button>
        </div>
      </form>

      <!-- 第三步 -->
      <template v-if="step == 3">
        <div class="am-text-center am-margin-top-xl">
          <Icon type="md-checkmark-circle" size="80" color="#e12f10" />
        </div>
        <p class="am-text-center am-text-xl">密码重置成功</p>
        <div
          style="color: #808080"
          class="am-text-center am-padding-vertical-sm"
        >
          3秒后将自动跳转到登录页面，若没有跳转，请
          <a href="/login" class="am-text-secondary color2">点击跳转</a>
        </div>
      </template>
    </div>

    <!-- 多个账号弹窗 -->
    <Modal
      v-model="userListModalVisible"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
      width="360"
      class-name="vertical-center-modal"
    >
      <div class="modal-title">
        系统检测到该手机号有多个用户<br />请选择一个
      </div>
      <ul class="modal-list">
        <li
          v-for="(item, index) in userList"
          :key="index"
          @click="selectUser(item)"
        >
          {{ item.userName }}
        </li>
      </ul>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { account } from "../../request";
import {
  randomNum,
  checkWeakPassword,
  validatePassword2,
} from "../../utils/utils";
export default {
  mixins: [siteMixin],
  data() {
    return {
      step: 1,
      errorTip: "",
      imageCode: "",
      imageCodeUrl: "",
      randomNum: "",
      phoneCodeText: "获取验证码",
      mobile: "",
      phoneCode: "",
      password: "",
      enterPassword: "",
      userListModalVisible: false,
      userList: [],
      userInfo: {
        agencyId: null,
        userName: null,
      },
    };
  },
  mounted() {
    this.setMetaData("忘记密码");
    this.getImageCodeUrl();
  },
  methods: {
    getImageCodeUrl() {
      var baseUrl = process.env.VUE_APP_VERIFY_CODE_URL;
      this.randomNum = randomNum(100000, 999999);
      this.imageCodeUrl = baseUrl + this.randomNum;
    },
    checkUserName(e) {
      const userName = e.target.value;
      if (!/^[1][3456789]\d{9}$/.test(userName)) return;
      account
        .checkUsernameWithCellphone(this.siteConfig.agencyId, userName)
        .then((res) => {
          console.log(res);
          if (res.status === 1) {
            if (res.data.length > 0) {
              this.userInfo = res.data[0];
            }
            if (res.data.length > 1) {
              this.userList = res.data;
              this.userListModalVisible = true;
            }
          } else {
            console.log(res.message);
          }
        });
    },
    selectUser(item) {
      this.userInfo = item;
      this.userListModalVisible = false;
    },
    getPhoneCode() {
      if (!this.isRequest) {
        if (!this.mobile) {
          this.errorTip = "请输入您的手机号";
          return;
        }
        if (!this.imageCode) {
          this.errorTip = "请输入图形验证码";
          return;
        }
        this.isRequest = true;
        account
          .getPhoneCode(
            this.mobile,
            0,
            2,
            this.siteConfig.agencyId,
            this.randomNum,
            this.imageCode
          )
          .then((result) => {
            if (result.status == 1) {
              let second = 60;
              let timer = setInterval(() => {
                second--;
                this.phoneCodeText = `还剩 ${second} 秒`;
                //console.log(second);
                if (second === 0) {
                  this.phoneCodeText = "重新获取";
                  this.isRequest = false;
                  clearInterval(timer);
                }
              }, 1000);
              this.errorTip = "";
            } else {
              this.isRequest = false;
              this.getImageCodeUrl();
              this.errorTip = result.message;
            }
          });
      }
    },
    checkPhoneCode() {
      if (!this.mobile) {
        this.errorTip = "请输入您的手机号";
        return;
      }
      if (!this.phoneCode) {
        this.errorTip = "请输入手机验证码";
        return;
      }
      this.errorTip = "";
      //this.step = 2;
      account.checkPhoneCode(this.mobile, this.phoneCode).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.step = 2;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    async resetPassword() {
      if (!this.password) {
        this.errorTip = "请输入新的密码";
        return;
      }
      if (!this.enterPassword) {
        this.errorTip = "请再次输入密码";
        return;
      }
      if (this.password) {
        const pswInfo = validatePassword2(this.password);
        if (!pswInfo.isValid) {
          // 密码格式错误时添加错误提示
          this.errorTip = pswInfo.message;
          return;
        }
      }
      if (this.password.trim() != this.enterPassword.trim()) {
        this.errorTip = "两次密码不一致";
        return;
      }
      this.errorTip = "";
      const flag = await checkWeakPassword(this.password);
      if (!flag) {
        this.$Message.warning({
          title: "提示",
          content: "该密码过于简单，请重新设置。",
        });
        return;
      }
      account
        .resetPassword(
          this.mobile,
          this.phoneCode,
          this.password,
          this.enterPassword,
          this.userInfo.AgencyId,
          this.userInfo.userName
        )
        .then((res) => {
          console.log(res);
          if (res.status === 1) {
            this.step = 3;
            setTimeout(() => {
              this.$router.push({
                name: "Login",
              });
            }, 3000);
          } else {
            this.$Message.error(res.message);
          }
        });
    },
    handleToHome() {
      if (this.$route.query.weekPass) {
        this.logout();
      } else {
        this.$router.push({
          name: "/",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
// .main {
//   position: static;

// }
.am-text-xl {
  font-size: 2em;
}
.steps {
  width: 90%;
  margin: 20px auto 36px;
}
.main {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url(../../assets/images/landing.png) center top;
}
.forget-header {
  color: #fff;
  width: 1000px;
  margin: 0 auto;
  .logo {
    display: block;
    width: 250px;
    height: 50px;
    overflow: hidden;
    img {
      max-width: 250px;
      max-height: 50px;
    }
  }
}
.am-padding-vertical-sm {
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: rgb(235, 8, 8);
}
.am-topbar-fixed-top {
  top: 0;
}
.am-topbar-fixed-bottom,
.am-topbar-fixed-top {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1000;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.am-margin-top {
  margin-top: 1.6rem;
}
.forget-header a {
  color: #fff;
}
.forget-wrap {
  position: absolute;
  width: 1000px;
  height: 460px;
  left: 50%;
  top: 50%;
  margin-left: -500px;
  margin-top: -230px;
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
  z-index: 99;
}
.forget-tips {
  width: 360px;
  height: 25px;
  margin: 0 auto;
  color: orangered;
}
.forget-title {
  background-color: #fff;
  color: #333;
  font-weight: normal;
  border-bottom: 1px solid #eee;
}
.am-text-lg {
  font-size: 1.8rem;
}
.am-padding-vertical {
  padding-top: 1.6rem;
  padding-bottom: 1.6rem;
}
.am-margin-horizontal {
  margin-left: 1.6rem;
  margin-right: 1.6rem;
}
.forget-form .am-form-group {
  position: relative;
}
.forget-form .am-form-group i {
  position: absolute;
  left: 0.5em;
  top: 50%;
  display: block;
  margin-top: -0.9em;
  line-height: 1;
  z-index: 2;
}
.forget-form .am-form-group input {
  // border-radius: 4px;
  /* font-size: 1.4rem; */
  padding: 0.7em;
  padding-left: 2.5em !important;
  outline: none;
}
.am-form-field {
  display: block;
  width: 100%;
  padding: 0.5em;
  font-size: 1.6rem;
  line-height: 1.2;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 2px;
  -webkit-appearance: none;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}
.am-btn-secondary {
  color: #fff;
  background-color: #3bb4f2;
  border-color: #3bb4f2;
}

.forget-form .image-code {
  position: absolute;
  top: 1px;
  right: 1px;
  display: block;
  width: 100px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.forget-form .mobile-code {
  text-align: center;
  position: absolute;
  top: 1px;
  right: 1px;
  bottom: 1px;
  width: 120px;
  border: 0;
  font-size: 1.6rem;
  line-height: 28px;
}

.forget-form .am-form-group {
  position: relative;
}
.am-margin-top-lg {
  margin-top: 2.4rem;
}
.forget-form {
  width: 360px;
  margin: 0 auto;
}
.am-form-group {
  margin-bottom: 1.5rem;
  .am-psw {
    height: 50px;
  }
  /deep/ .ivu-input {
    height: 40px;
  }
  /deep/ .ivu-input-suffix {
    top: 4px;
  }
}
.am-btn {
  display: inline-block;
  margin-bottom: 0;
  padding: 0.5em 1em;
  vertical-align: middle;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 0;
  cursor: pointer;
  outline: 0;
  -webkit-appearance: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: background-color 0.3s ease-out, border-color 0.3s ease-out;
  transition: background-color 0.3s ease-out, border-color 0.3s ease-out;
}
.am-btn-block {
  display: block;
  width: 100%;
  padding-left: 0;
  padding-right: 0;
}
.am-text-center {
  text-align: center;
}
</style>
